"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLoadChatUser = exports.useLoadChatUsers = exports.useChatUser = exports.useFindUser = exports.useAll = exports.useUserActivity = exports.useAllActivity = void 0;
/**
 * @packageDocumentation @module Users
 */
var react_1 = require("react");
var effector_react_1 = require("effector-react");
var chat_1 = require("@yeobill/chat");
var utils_1 = require("../utils");
var findByLogin_1 = require("./findByLogin");
Object.defineProperty(exports, "findByLogin", { enumerable: true, get: function () { return findByLogin_1.findByLogin; } });
var findByName_1 = require("./findByName");
Object.defineProperty(exports, "findByName", { enumerable: true, get: function () { return findByName_1.findByName; } });
var findByArea_1 = require("./findByArea");
Object.defineProperty(exports, "findByArea", { enumerable: true, get: function () { return findByArea_1.findByArea; } });
var findUsersByFilter_1 = require("./findUsersByFilter");
Object.defineProperty(exports, "findUsersByFilter", { enumerable: true, get: function () { return findUsersByFilter_1.findUsersByFilter; } });
var findUsersByIds_1 = require("./findUsersByIds");
Object.defineProperty(exports, "findUsersByIds", { enumerable: true, get: function () { return findUsersByIds_1.findUsersByIds; } });
var getUser_1 = require("./getUser");
Object.defineProperty(exports, "getUser", { enumerable: true, get: function () { return getUser_1.getUser; } });
var searchUsersByQuery_1 = require("./searchUsersByQuery");
Object.defineProperty(exports, "searchUsersByQuery", { enumerable: true, get: function () { return searchUsersByQuery_1.searchUsersByQuery; } });
var updateUserByExternalId_1 = require("./updateUserByExternalId");
Object.defineProperty(exports, "updateUserByExternalId", { enumerable: true, get: function () { return updateUserByExternalId_1.updateUserByExternalId; } });
exports.useAllActivity = function () {
    return effector_react_1.useStore(chat_1.Users.Activity$);
};
exports.useUserActivity = function (_a) {
    var userId = _a.userId, _b = _a.minutes, minutes = _b === void 0 ? 5 : _b, _c = _a.interval, interval = _c === void 0 ? 15000 : _c;
    var activity = effector_react_1.useStore(chat_1.Users.Activity$);
    var loadUserActivity = react_1.useCallback(function () {
        chat_1.Users.loadLastUserActivity(userId);
    }, [userId]);
    utils_1.useInterval(loadUserActivity, interval);
    react_1.useEffect(function () {
        loadUserActivity();
    }, [loadUserActivity]);
    var lastActivity = activity[userId];
    var isOnline = lastActivity < minutes * 60;
    // 0 if user online or undefined if user never registered in chat
    return [isOnline, lastActivity];
};
exports.useAll = function () {
    return effector_react_1.useStore(chat_1.Users.Users$);
};
exports.useFindUser = function (filter) {
    var users = exports.useAll();
    return react_1.useMemo(function () {
        return Object.values(users).find(filter);
    }, [users, filter]);
};
exports.useChatUser = function (qbUserId) {
    return exports.useFindUser(function (QBUser) { return QBUser.id === qbUserId; });
};
exports.useLoadChatUsers = function (qbUserIds) {
    var _a = react_1.useState('initial'), state = _a[0], setState = _a[1];
    react_1.useEffect(function () {
        if (state !== 'initial') {
            return;
        }
        setState('progress');
        chat_1.Users.findUsersByIds(qbUserIds).then(function () {
            setState('loaded');
        });
    }, []);
};
exports.useLoadChatUser = function (qbUserId) {
    var _a = react_1.useState('initial'), state = _a[0], setState = _a[1];
    react_1.useEffect(function () {
        if (state !== 'initial') {
            return;
        }
        setState('progress');
        chat_1.Users.loadUserById(qbUserId).then(function () {
            setState('loaded');
        });
    }, []);
};
//# sourceMappingURL=index.js.map